import { render, staticRenderFns } from "./WorkIconLogut.vue?vue&type=template&id=4dcba704"
import script from "./WorkIconLogut.vue?vue&type=script&lang=js"
export * from "./WorkIconLogut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports